import { createRouter, createWebHistory } from '@ionic/vue-router';
import { type NavigationGuardWithThis, type RouteRecordRaw } from 'vue-router';
import useTraewellingOAuth from '@/composables/useTraewellingOAuth';
import { ROUTE } from '@/router/names';

const processTraewellingOAuthResponse: NavigationGuardWithThis<unknown> = async (to) => {
  const code = to.query['code'] as string;
  const state = to.query['state'] as string;

  const traewellingOAuth = useTraewellingOAuth();
  await traewellingOAuth.handleTraewellingResponse(code, state);
};

const mapQuelleString = (quelle: string | string[] | undefined) => {
  if (typeof quelle === 'string') {
    return Number.parseInt(quelle, 10);
  }
  return 0;
};

const routes: Array<RouteRecordRaw> = [
  {
    path: '',
    name: ROUTE.HOME,
    component: () => import('../views/HomeView.vue'),
  },
  {
    path: '/search',
    name: ROUTE.OMNI_SEARCH,
    component: () => import('../views/OmniSearch.vue'),
  },
  {
    path: '/trainDetails/:quelle/:id',
    name: ROUTE.TRAIN_DETAILS,
    props: (route) => ({ ...route.params, ...route.query, ...{ quelle: mapQuelleString(route.params.quelle) } }),
    component: () => import('../views/RouteDetails.vue'),
  },
  {
    path: '/stationBoard/:evaNummer/:ril100?/:name?',
    name: ROUTE.STATION_BOARD,
    props: true,
    component: () => import('../views/StationBoard.vue'),
  },
  {
    path: '/route/:from/:to/:date',
    name: ROUTE.ROUTE_SEARCH,
    props: true,
    component: () => import('../views/RouteSearch.vue'),
  },
  {
    path: '/connection/:quelle/:id/:startzeit',
    name: ROUTE.ROUTE_DETAILS,
    props: (route) => ({ ...route.params, ...route.query, ...{ quelle: mapQuelleString(route.params.quelle) } }),
    component: () => import('../views/RouteDetails.vue'),
  },
  {
    path: '/alternative/:quelle/:id/:startzeit',
    name: ROUTE.ALTERNATIVE_SEARCH,
    props: (route) => ({ ...route.params, ...{ quelle: mapQuelleString(route.params.quelle) } }),
    component: () => import('../views/AlternativeSearchView.vue'),
  },
  {
    path: '/alternative/:oldQuelle/:oldId/:oldStartzeit/:newQuelle/:newId/:newStartzeit',
    name: ROUTE.ALTERNATIVE_ROUTE,
    props: (route) => ({
      ...route.params,
      ...{
        oldQuelle: mapQuelleString(route.params.oldQuelle),
        newQuelle: mapQuelleString(route.params.newQuelle),
      },
    }),
    component: () => import('../views/AlternativeDetails.vue'),
  },
  {
    path: '/myRoutes',
    name: ROUTE.MY_ROUTES,
    component: () => import('../views/MyRoutes.vue'),
  },
  {
    path: '/myPickups',
    name: ROUTE.MY_PICKUPS,
    component: () => import('../views/MyPickups.vue'),
  },
  {
    path: '/myConnection/:quelle/:id/:startzeit',
    name: ROUTE.MY_ROUTE_DETAILS,
    props: (route) => ({ ...route.params, ...route.query, ...{ quelle: mapQuelleString(route.params.quelle) } }),
    component: () => import('../views/MyRouteDetails.vue'),
  },
  {
    path: '/settings',
    name: ROUTE.SETTINGS,
    component: () => import('../views/SettingsView.vue'),
  },
  {
    path: '/about',
    name: ROUTE.ABOUT,
    component: () => import('../views/AboutView.vue'),
  },
  {
    path: '/traewelling-callback',
    name: ROUTE.TRAEWELLING_OAUTH_CALLBACK,
    component: () => import('../views/SettingsView.vue'),
    beforeEnter: processTraewellingOAuthResponse,
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

export default router;
